export const VITAL_TYPE_MAPPING = {
  BP: 'BP',
  BG: 'BG',
  HS: 'HS',
  HR: 'HR',
  RR: 'RR',
  PO: 'PO',
  PO_HR: 'PO_HR',
  BP_HR: 'BP_HR',
  HR_PO: 'PO_HR',
  HR_BP: 'BP_HR',
  ECG: 'ECG',
  BTM: 'BTM',
  HILLROM_WACSM: 'HILLROM_WACSM',
  BP_PO_HR_BTM: 'BP_PO_HR_BTM',
  BP_BTM_HR_PO: 'BP_PO_HR_BTM',
  BP_PO_HR_BTM_RR: 'BP_PO_HR_BTM_RR',
  BP_BTM_HR_PO_RR: 'BP_PO_HR_BTM_RR',
  PO_HR_RR: 'PO_HR_RR',
  HR_PO_RR: 'PO_HR_RR',
  MONIT: 'MONIT',
  BC: 'BC',
};

export const VITAL_NAME_MAPPING = {
  [VITAL_TYPE_MAPPING.BP]: 'Blood Pressure',
  [VITAL_TYPE_MAPPING.BG]: 'Blood Glucose',
  [VITAL_TYPE_MAPPING.HS]: 'Weight',
  [VITAL_TYPE_MAPPING.HR]: 'Heart Rate',
  [VITAL_TYPE_MAPPING.RR]: 'Respiration Rate',
  [VITAL_TYPE_MAPPING.PO]: 'SpO2',
  [VITAL_TYPE_MAPPING.PO_HR]: 'SpO2 and Heart Rate',
  [VITAL_TYPE_MAPPING.BP_HR]: 'Blood Pressure and Heart Rate',
  [VITAL_TYPE_MAPPING.ECG]: 'Holter Monitoring Test',
  [VITAL_TYPE_MAPPING.BTM]: 'Temperature',
  [VITAL_TYPE_MAPPING.HILLROM_WACSM]: '4-in-1 Vitals',
  [VITAL_TYPE_MAPPING.BP_PO_HR_BTM]: '4-in-1 Vitals',
  [VITAL_TYPE_MAPPING.BP_BTM_HR_PO]: '4-in-1 Vitals',
  [VITAL_TYPE_MAPPING.BP_PO_HR_BTM_RR]: '5-in-1 Vitals',
  [VITAL_TYPE_MAPPING.BP_BTM_HR_PO_RR]: '5-in-1 Vitals',
  [VITAL_TYPE_MAPPING.PO_HR_RR]: 'Sp02, Heart Rate and Respiration Rate',
  [VITAL_TYPE_MAPPING.MONIT]: 'Pads',
  [VITAL_TYPE_MAPPING.BC]: 'Body Composition',
};

export const TASK_STATUS_MAPPING = {
  new: 'Upcoming',
  missed: 'Missed',
  done: 'Completed',
  final: 'Completed',
};

export const VITAL_DISPLAY_MAPPING = {
  'blood glucose': 'Glucose',
  spo2: 'Oxygen',
  'oxygen saturation': 'Oxygen',
  'heart rate': 'HR',
  'systolic blood pressure': 'SYS',
  'diastolic blood pressure': 'DIA',
  'sys': 'SYS',
  'dia': 'DIA',
  'body temperature': 'Temp',
  'body weight': 'Weight',
  'respiration rate': 'RR',
  'pollutionrange': 'Pollution Range',
  'pollution range': 'Pollution Range',
  'pollutionvalue': 'Pollution Value',
  'pollution value': 'Pollution Value',
  'bcweight': 'Weight',
  'bcbmi': 'BMI',
  'bcbodyfat': 'Body Fat',
  'bcbodywater': 'Body Water',
  'bcmusclemass': 'Muscle',
  'bcleanmass': 'Lean Mass',
  'bcbonemass': 'Bone Mass',
  'bcvisceralfat': 'Visceral Fat',
  'bcbmr': 'BMR',
  // Body Composition components carry these display names (vital_dimension.display_name).
  'body mass index': 'BMI',
  'body fat': 'Body Fat',
  'body water': 'Body Water',
  'muscle mass': 'Muscle',
  'lean mass': 'Lean Mass',
  'bone mass': 'Bone Mass',
  'visceral fat': 'Visceral Fat',
  'basal metabolic rate': 'BMR',
};

export const UNIT_DISPLAY_MAPPING = {
  'blood glucose': 'mmol/L',
  'bg': 'mmol/L',
  'spo2': '%',
  'po': '%',
  'Oxygen': '%',
  'oxygen saturation': '%',
  'heart rate': 'beats/min',
  'hr': 'beats/min',
  'systolic blood pressure': 'mmHg',
  'diastolic blood pressure': 'mmHg',
  'sys': 'mmHg',
  'dia': 'mmHg',
  'body temperature': '°C',
  'btm': '°C',
  'body weight': 'kg',
  'hs': 'kg',
  'respiration rate': 'beadth/min',
  'rr': 'beadth/min',
  'pollutionrange': 'channels',
  'pollution range': 'channels',
  'pollutionvalue': '',
  'pollution value': '',
  'bcweight': 'kg',
  'bcbmi': 'kg/m²',
  'bcbodyfat': '%',
  'bcbodywater': '%',
  'bcmusclemass': 'kg',
  'bcleanmass': 'kg',
  'bcbonemass': 'kg',
  'bcvisceralfat': '',
  'bcbmr': 'kcal/day',
  'body mass index': 'kg/m²',
  'body fat': '%',
  'body water': '%',
  'muscle mass': 'kg',
  'lean mass': 'kg',
  'bone mass': 'kg',
  'visceral fat': '',
  'basal metabolic rate': 'kcal/day',
};

export const MEALTIME_MAPPING = {
  ACM: 'Before Meals',
  PCM: 'After Meals',
  ACD: 'Before Meals',
  PCD: 'After Meals',
  ACV: 'Before Meals',
  PCV: 'After Meals',
  HS: 'Before Meals',
  PHS: 'After Meals'
};

export const MEALTIME_NAME_MAPPING = {
  ACM: 'Before Breakfast',
  PCM: 'After Breakfast',
  ACD: 'Before Lunch',
  PCD: 'After Lunch',
  ACV: 'Before Dinner',
  PCV: 'After Dinner',
  HS: 'Bedtime',
  PHS: 'After Midnight'
};

export default {
  VITAL_TYPE_MAPPING,
  VITAL_NAME_MAPPING,
  TASK_STATUS_MAPPING,
  MEALTIME_MAPPING,
  MEALTIME_NAME_MAPPING
};
